module.exports = __webpack_public_path__ + "img/checked.8acca79d.svg";